export enum APPLICATION_STATUS {
	PENDING_ANSWER = "PENDING_ANSWER",
	ACCEPTED = "ACCEPTED",
	DECLINED = "DECLINED",
	CANCELLED = "CANCELLED",
}
